import { Col, Row } from "react-bootstrap";
import water from "../../../../assets/images/ZX.webp";
import boat from "../../../../assets/images/DF.webp";
import train from "../../../../assets/images/trainMobile.webp";
import enjoy from "../../../../assets/images/3.webp";
import craft from "../../../../assets/images/handcraftMobile.webp";
import cafe from "../../../../assets/images/cafeMobile.webp";
import card1 from "../../../../assets/images/DSC00925copy.webp";
import card2 from "../../../../assets/images/DSC04908.webp";
import card3 from "../../../../assets/images/DSC00778.webp";
import card4 from "../../../../assets/images/DSC00105copy.webp";
import card5 from "../../../../assets/images/11-min.webp";
import card6 from "../../../../assets/images/DSC00105copy.webp";
import card7 from "../../../../assets/images/7777.webp";
import card8 from "../../../../assets/images/JJJ.webp";
import card9 from "../../../../assets/images/1111.webp";
import card10 from "../../../../assets/images/mirrormaze.webp";
import card11 from "../../../../assets/images/DSC00942.webp";
import card12 from "../../../../assets/images/wsa.webp";
import card13 from "../../../../assets/images/DSC06071.webp";
import card14 from "../../../../assets/images/DSC06072.webp";
import card15 from "../../../../assets/images/teajug.webp";
import card16 from "../../../../assets/images/DSC06074-min.webp";
import card17 from "../../../../assets/images/flyingdutchman-min.webp";
import card18 from "../../../../assets/images/slambob-min.webp";
import card19 from "../../../../assets/images/trafficpark-min.webp";
import card20 from "../../../../assets/images/Frame86.webp";
import card21 from "../../../../assets/images/leather.webp";
import card22 from "../../../../assets/images/fancy.webp";
import card23 from "../../../../assets/images/candies.webp";
import card24 from "../../../../assets/images/DSC05759.webp";
import card25 from "../../../../assets/images/chocolate.webp";
import card26 from "../../../../assets/images/livePlants.webp";
import "./styles.scss";
const ActivityCard = () => {
  const cards1 = [
    {
      image: card1,
      head: "Inflatable Slide",
    },
    {
      image: card2,
      head: "Climbing Wall",
    },
    {
      image: card3,
      head: "Kids Park",
    },
    {
      image: card4,
      head: "Rope Course",
    },
  ];
  const cards2 = [
    {
      image: card5,
      head: "Zip Line",
    },
    {
      image: card6,
      head: "Burma Bridge",
    },
    {
      image: card7,
      head: "Zip Cycle",
    },
    {
      image: card8,
      head: "Giant Swing",
    },
  ];
  const cards3 = [
    {
      image: card9,
      head: "Obstacle Course",
    },
    {
      image: card10,
      head: "Mirror Maze",
    },
    {
      image: card11,
      head: "Water Park",
    },
    {
      image: card12,
      head: "Burma Bridge",
    },
  ];
  const cards4 = [
    {
      image: card13,
      head: "Sovenir Shop",
    },
    {
      image: card14,
      head: "Ceramic Shop",
    },
    {
      image: card15,
      head: "Tea Boutique",
    },
    {
      image: card16,
      head: "Honey Store",
    },
  ];
  const cards5 = [
    {
      image: card17,
      head: "Flying Dutchman",
    },
    {
      image: card18,
      head: "Slam Bob",
    },
    {
      image: card19,
      head: "Traffic Park",
    },
    {
      image: card20,
      head: "Fish Spa",
    },
  ];
  const cards6 = [
    {
      image: card21,
      head: "Leather Store",
    },
    {
      image: card22,
      head: "Fancy Store",
    },
    {
      image: card23,
      head: "Candies Store",
    },
    {
      image: card25,
      head: "Chocolates Store",
    },
    {
      image: card24,
      head: "Floating Market",
    },

    {
      image: card26,
      head: "Live Plants",
    },
  ];
  return (
    <>
      <div className="cardCntainer">
        <Row className="g-4">
          {cards1?.map((item: any, index: any) => (
            <Col md={3} xs={6} key={index}>
              <div className="cardHead">{item?.head}</div>
              <div className="card-image">
                <img
                  src={item?.image}
                  alt="Image"
                  className="w-100 custom-img"
                />
              </div>
            </Col>
          ))}
        </Row>
      </div>
      <Row className="g-0 mx-0">
        <Col md={12} sm={12}>
          <div className="textBoxMobile">
            <div className="fancytxt1"> Enjoy</div>
            <div className="upperHeadTxt">BE A TENZO</div>
            <div className="headerTxtMain">BE HAPPY</div>
          </div>
        </Col>
        <Col md={12} xs={12}>
          <Row className="g-0 mx-0">
            <Col md={8} sm={12}>
              <img
                src={enjoy}
                width={"100%"}
                style={{ objectFit: "contain" }}
              />
            </Col>
            <Col md={4} sm={12}>
              <div className="textBox">
                <div className="fancytxt1" style={{ width: "80%" }}>
                  Enjoy
                </div>
                <div>
                  <div className="upperHeadTxt">BE A TENZO</div>
                  <div className="headerTxtMain">BE HAPPY</div>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <div className="cardCntainer">
        <Row className="g-4">
          {cards2?.map((item: any, index: any) => (
            <Col md={3} xs={6} key={index}>
              <div className="cardHead">{item?.head}</div>
              <img src={item?.image} alt="Image" className="w-100 custom-img" />
            </Col>
          ))}
        </Row>
      </div>
      <Row className="g-0 mx-0">
        <Col md={12} xs={12}>
          <div className="textBoxMobile">
            <div className="fancytxt2">Water</div>
            <div className="upperHeadTxt">FAMILY ORIENTED </div>
            <div className="headerTxtMain">Swimming Pool</div>
            <img
              src={water}
              style={{ objectFit: "contain" }}
              width={"100%"}
              alt="waterImage"
            />
          </div>
        </Col>
        <Col md={12} xs={12}>
          <div className="waterImageParent">
            <Col md={6}>
              <div className="textBox">
                <div className="fancytxt2">Water</div>
                <div>
                  <div className="upperHeadTxt">BIGGEST WATER PARK </div>
                  <div className="headerTxtMain">In Wayanad</div>
                </div>
              </div>
            </Col>
            <Col md={6} />
          </div>
        </Col>
      </Row>
      <div className="cardCntainer">
        <Row className="g-4">
          {cards3?.map((item: any, index: any) => (
            <Col md={3} xs={6} key={index}>
              <div className="cardHead">{item?.head}</div>
              <img src={item?.image} alt="Image" className="w-100 custom-img" />
            </Col>
          ))}
        </Row>
      </div>
      <Row className="g-0 mx-0">
        <Col md={12} xs={12}>
          <div className="textBoxMobile">
            <div className="fancytxt2">Boat</div>

            <div className="upperHeadTxt">KIDS</div>
            <div className="headerTxtMain">Park</div>
            <img
              src={boat}
              style={{ objectFit: "contain" }}
              width={"100%"}
              alt="boatImage"
            />
          </div>
        </Col>
        <Col md={12} sm={12}>
          <div className="boatImageParent">
            <Row className="mx-0 g-0">
              {" "}
              <Col md={6} />
              <Col md={6}>
                <div className="textBox">
                  <div className="fancytxt2">Boat</div>
                  <div>
                    <div className="upperHeadTxt">KIDS</div>
                    <div className="headerTxtMain">Park</div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      <div className="cardCntainer">
        <Row className="g-4">
          {cards5?.map((item: any, index: any) => (
            <Col md={3} xs={6} key={index}>
              <div className="cardHead">{item?.head}</div>
              <img src={item?.image} alt="Image" className="w-100 custom-img" />
            </Col>
          ))}
        </Row>
      </div>
      <Row className="g-0 mx-0">
        <Col md={12} xs={12}>
          <div className="textBoxMobile">
            <div className="fancytxt3">Train</div>
            <div className="upperHeadTxt">RIDE WITH KIDS ON</div>
            <div className="headerTxtMain">Toy Train</div>
            <img src={train} style={{ objectFit: "contain" }} width={"100%"} />
          </div>
        </Col>
        <Col md={12} xs={12}>
          <div className="trainImageParent">
            <Col md={5}>
              <div className="textBox">
                <div className="fancytxt3">Train</div>
                <div>
                  <div className="upperHeadTxt">RIDE WITH KIDS ON</div>
                  <div className="headerTxtMain">Toy Train</div>
                </div>
              </div>
            </Col>
            <Col md={7} />
          </div>
        </Col>
      </Row>
      <div className="cardCntainer">
        <Row className="g-4">
          {cards4?.map((item: any, index: any) => (
            <Col md={3} xs={6} key={index}>
              <div className="cardHead">{item?.head}</div>
              <img src={item?.image} alt="Image" className="w-100 custom-img" />
            </Col>
          ))}
        </Row>
      </div>

      <Row className="g-0 mx-0">
        <Col md={12} xs={12}>
          <div className="textBoxMobile">
            <div className="fancytxt1">Cafe</div>
            <div className="upperHeadTxt">
              A COZY HEAVEN WHERE
              <br /> EVERY SIP TELLS
            </div>
            <div className="headerTxtMain">A Story</div>
            <img
              src={cafe}
              style={{ objectFit: "contain" }}
              width={"100%"}
              alt="cafeImage"
            />
          </div>
        </Col>
        <Col md={12} xs={12}>
          <div className="cafeImageParent">
            <Row className="g-0 mx-0">
              <Col md={7} />

              <Col md={5} className="pt-5  d-flex flex-column align-items-end">
                <div className="textBox">
                  <div className="fancytxt1">Cafe</div>
                  <div>
                    <div className="upperHeadTxt">
                      A COZY HEAVEN WHERE
                      <br /> EVERY SIP TELLS
                    </div>
                    <div className="headerTxtMain">A Story</div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      <div className="cardCntainer">
        <Row className="g-4">
          {cards6?.slice(0, 4)?.map((item: any, index: any) => (
            <Col md={3} xs={6} key={index}>
              <div className="cardHead">{item?.head}</div>
              <img src={item?.image} alt="Image" className="w-100 custImg" />
            </Col>
          ))}
          {cards6?.slice(4, 6)?.map((item: any, index: any) => (
            <Col md={6} xs={6} key={index}>
              <div className="cardHead">{item?.head}</div>
              <img src={item?.image} alt="Image" className="w-100 custImg" />
            </Col>
          ))}
        </Row>
      </div>
      <Row className="g-0 mx-0">
        <Col sm={12} xs={12}>
          <div className="textBoxMobile">
            <div className="fancytxt3">Handcraft</div>
            <div className="upperHeadTxt">DISCOVER THE BEAUTY OF</div>
            <div className="headerTxtMain">Handcrafting</div>
            <img
              src={craft}
              style={{ objectFit: "contain" }}
              width={"100%"}
              alt="craftImage"
            />
          </div>
        </Col>
        <Col md={12} xs={12}>
          <div className="craftImageParent">
            <Col md={6} className="pt-5 d-flex flex-column align-items-center">
              <div className="textBox pt-5">
                <div className="fancytxt3">Handcraft</div>
                <div>
                  <div className="upperHeadTxt">DISCOVER THE BEAUTY OF</div>
                  <div className="headerTxtMain">Handcrafting</div>
                </div>
              </div>
            </Col>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default ActivityCard;
